<template>
    <b-tag size="is-medium" :type="tagType">
        <span>{{localDisplayValue}}</span>
        <span v-if="editAllowed">
            <button
              :class="['button is-small is-light', tagType]"
              @click.prevent="$emit('edit-clicked', edit)"
            >
                <b-icon icon="pencil"/>
            </button>
        </span>
    </b-tag>
</template>

<script>
export default {
  name: 'KycDetailsFieldTag',
  props: [
    'editAllowed',
    'name',
    'value',
    'displayValue'
  ],
  data () {
    return {
      localName: this.name,
      localValue: this.value,
      localDisplayValue: this.displayValue
    }
  },
  computed: {
    edit () {
      return {
        name: this.localName,
        value: this.localValue
      }
    },
    tagType () {
      if (this.localName === 'status' && this.localValue === 20) return 'is-success'
      if (this.localName === 'status' && this.localValue === 30) return 'is-dark'
      return 'is-light'
    }
  },
  watch: {
    name () {
      this.localName = this.name
    },
    value () {
      this.localValue = this.value
    },
    displayValue () {
      this.localDisplayValue = this.displayValue
    }
  }
}
</script>

<style scoped>

</style>
